<template>
  <div>
    <div>
      <p><b>File Name</b></p>
      <input v-model="new_file_name" type="text" placeholder="שם קובץ.pdf">
    </div>
    <div class="vertical_space"></div>
    <div v-if="!file_helper.isAuthorized(new_file_name)">
      <p class="margin_0"><b>אנא תקנ/י את השגיאות הבאות:</b></p>
      <p class="margin_0" v-for="file_error in file_errors" :key="file_error">תו לא מקובל - "<b>{{ file_error }}</b>"</p>
    </div>
    <div class="modal_footer">
      <a
        @click="submit()"
        :class="{ 'is-loading': is_loading, faded: !file_helper.isAuthorized(new_file_name) }"
        class="button is-info"
        >Submit</a
      >
    </div>
  </div>
</template>
<script>
import { mapMutations, mapActions } from 'vuex'
import FileHelper from '@/classes/file_helper.js'
export default {
  name: 'file-editor',
  props: ['payload'],
  data () {
    return {
      is_loading: false,
      file_helper: new FileHelper(),
      new_file_name: this.payload.file.name,
      file_errors: ''
    }
  },
  watch: {
    new_file_name () {
      this.file_errors = this.file_helper.getErrors(this.new_file_name)
    }
  },
  methods: {
    submit () {
      this.is_loading = true
      this.$network_utils.updateFile({
        file_name: this.payload.file.name,
        new_file_name: this.new_file_name,
        resource_type: this.payload.resource_type,
        resource_id: this.payload.resource_id,
      }).then(() => {
        this.is_loading = false
        if (this.payload.refresh) {
          this.payload.refresh()
        }
        this.showToast('הקובץ עודכן')
        this.removeModal(this.payload)
      })
    },
    ...mapActions('toasts', ['showToast']),
    ...mapMutations('modals', ['removeModal'])
  }
}
</script>
